var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSomethingWrong({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 119,
    viewBox: "0 0 132 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4682_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7998 8.3002C58.3998 -1.4998 72.4998 -1.4998 78.1998 8.3002L103.7 52.4002L129.2 96.5002C134.8 106.3 127.8 118.5 116.5 118.5H65.5998H14.6998C3.39979 118.5 -3.6002 106.3 1.9998 96.5002L27.4998 52.4002L52.7998 8.3002Z",
    fill: "url(#paint0_linear_4682_70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7998 93.3003C68.5998 92.1003 67.1998 91.6003 65.4998 91.6003C63.8998 91.6003 62.4998 92.2003 61.2998 93.3003C60.0998 94.5003 59.4998 95.9003 59.4998 97.6003C59.4998 99.3003 60.0998 100.7 61.2998 101.9C62.4998 103.1 63.8998 103.7 65.4998 103.7C67.1998 103.7 68.5998 103.1 69.7998 101.9C70.9998 100.7 71.5998 99.3003 71.5998 97.6003C71.4998 95.8003 70.8998 94.5003 69.7998 93.3003ZM71.3998 38.3003C71.5998 36.8003 71.6998 35.6003 71.6998 34.6003C71.6998 31.8003 71.0998 29.8003 69.8998 28.4003C68.6998 27.0003 67.2998 26.3003 65.4998 26.3003C63.7998 26.3003 62.2998 27.0003 61.0998 28.4003C59.8998 29.8003 59.2998 31.7003 59.2998 34.1003C59.2998 34.9003 59.3998 36.2003 59.5998 38.1003L64.3998 82.4003H66.4998L71.3998 38.3003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4682_70",
    x1: 65.6136,
    y1: 4.60189,
    x2: 65.6136,
    y2: 114.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F35181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63A61"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4682_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 119,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWrong);
export default __webpack_public_path__ + "static/media/somethingWrong.aa4a646c23a427b829996831735ae857.svg";
export { ForwardRef as ReactComponent };